/* --------------------------------------------------------------------------------------
   app.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

import angular from 'angular'
import uiRouter from "@uirouter/angularjs";
import 'angular-translate'
import 'angular-translate-loader-static-files'

import { mainComponent, mainCtrl } from './components/main.component'
import { appService } from './services/app.service'
import { appSettings } from './constants/appSettings.const'
import { appAuthModule } from './auth/auth'
import { appPrintTestsModule } from './printTests/printTests'
import { appGradeTestsModule } from './gradeTests/gradeTests'
import { appResultsModule } from './results/results'
import { appCommonModule } from './common/common'
import { appXrxWrappersModule } from './xrxWrappers/xrxWrappers'

export default angular.module('app', [
  'ui.router', 'pascalprecht.translate',
  'app.auth', 'app.printTests', 'app.gradeTests', 'app.results', 'app.common', 'app.xrxWrappers'
])
  .component('main', mainComponent)
  .controller('mainCtrl', mainCtrl)
  .service('appService', appService)
  .constant('appSettings', appSettings)
  .config(($stateProvider, $urlRouterProvider) => {
    /*ngInject*/
    $stateProvider.state('auth', {
      url: '/',
      component: 'auth'
    })
    .state('main', {
      component: 'main'
    })
    .state('printTests', {
      component: 'printTests'
    })
    .state('gradeTests', {
      component: 'gradeTests'
    })
    .state('results', {
      component: 'results'
    })

    $urlRouterProvider.otherwise('/')
  })
  .config(($translateProvider) => {
  /*ngInject*/
    $translateProvider.useStaticFilesLoader({
      files: [{
        prefix: './i18n/locale-',
        suffix: '.json'
       }]
    });
    const availableLanguages = ['en', 'fr', 'es']
    const currentLang = navigator.language.split('-')[0]
    const prefLang = availableLanguages.includes(currentLang) ? currentLang : 'en'    
    $translateProvider.preferredLanguage(prefLang);
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
  });



// WEBPACK FOOTER //
// ./src/app/app.js